import React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { Text } from '../Text';

interface ISliderPaginationDots {
  dots: any;
  titles?: string[];
  currentSlide: number;
  asNumbers?: boolean;
}

const StyledSliderPaginationDots = styled.div`
  .dots {
    padding: ${rem(`12px`)};
    background-color: ${({ theme }) => theme.colors.blue_1_65};
    border-radius: ${rem(`12px`)};
  }
  .dots__numbers {
    width: 100%;
    height: ${rem(`36px`)};
    padding: 0 ${rem(`42px`)};
    display: flex;
    justify-content: center;
    align-items: center;
    ${({ theme }) => theme.breakpoints.phone`
        height: ${rem(`48px`)};
        padding: 0 ${rem(`60px`)};
      `}
  }
  .dots__list {
    padding: 0 ${rem(`42px`)};
    ${({ theme }) => theme.breakpoints.phone`
      padding: 0 ${rem(`60px`)};
    `}
    ${({ theme }) => theme.breakpoints.desktop`
      padding: 0 ${rem(`72px`)};
    `}
  }
  .dots__list li {
    width: ${rem(`12px`)};
    height: ${rem(`36px`)};
    margin: 0 ${rem(`4px`)};
    ${({ theme }) => theme.breakpoints.phone`
      width: ${rem(`24px`)};
      height: ${rem(`48px`)};
      margin: 0 ${rem(`5px`)};
    `}
    ${({ theme }) => theme.breakpoints.desktop`
      width: ${rem(`36px`)};
      height: ${rem(`72px`)};
    `}
  }
  .dots__list li button {
    position: relative;
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    ${({ theme }) => theme.breakpoints.desktop`
      &:hover:before {
        opacity: 1;
        color: ${theme.colors.purple_2};
        transition: opacity 300ms ease-in-out;
      }
    `}
  }
  .dots__list button:before {
    right: 0;
    left: ${rem(`-4px`)};
    top: ${rem(`2px`)};
    bottom: 0;
    margin: auto;
    font-size: ${rem(`18px`)};
    opacity: 0.25;
    color: ${({ theme }) => theme.colors.purple_2};
    transition: opacity 300ms ease-in-out;
    ${({ theme }) => theme.breakpoints.phone`
      left: 0;
      top: 0;
    `}
  }
  .dots__list .slick-active button:before {
    opacity: 1;
    color: ${({ theme }) => theme.colors.yellow_2};
  }
`;

export const SliderPaginationDots = ({
  dots,
  titles,
  currentSlide,
  asNumbers = false,
}: ISliderPaginationDots) => {
  return (
    <StyledSliderPaginationDots>
      <div className="dots">
        {asNumbers ? (
          <div className="dots__numbers">
            <Text type="body1" tag="span" color="white_1" noRhythem>
              {titles && titles[currentSlide]} {currentSlide + 1}/{dots.length}
            </Text>
          </div>
        ) : (
          <>
            {titles && (
              <Text type="body1" tag="span" color="white_1" noRhythem>
                {titles[currentSlide]} {currentSlide + 1} / {dots.length}
              </Text>
            )}
            <ul className="dots__list">{dots}</ul>
          </>
        )}
      </div>
    </StyledSliderPaginationDots>
  );
};
